export default __webpack_public_path__ + "static/media/Icon-check.5798994c.svg";